var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "record-viewer",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.$_.noop.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "a-tabs",
        { attrs: { "default-active-key": "1" } },
        [
          _c(
            "a-tab-pane",
            { key: "1", attrs: { tab: _vm.$t("modules.recordDetail") } },
            [
              _c(
                "a-spin",
                { attrs: { spinning: _vm.loading, size: "large" } },
                [
                  _vm.table && _vm.record
                    ? _c("div", { staticClass: "record-container" }, [
                        _c(
                          "div",
                          { staticClass: "field-grid" },
                          _vm._l(_vm.table.fields, function (field) {
                            return _c(
                              "div",
                              { key: field._id, staticClass: "field-item" },
                              [
                                _c(
                                  "label",
                                  { staticClass: "field-label" },
                                  [
                                    _c("FieldIcon", {
                                      staticClass: "field-icon",
                                      attrs: { type: field.fieldType },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(field.name))]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.record
                                  ? _c(_vm.getCellComponent(field.fieldType), {
                                      tag: "component",
                                      staticStyle: { "min-height": "28px" },
                                      attrs: {
                                        field: field,
                                        record: _vm.record,
                                        outlined: "",
                                      },
                                      on: {
                                        "update-record": _vm.handleRecordUpdate,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ])
                    : _c("div", { staticClass: "empty-info" }, [
                        _vm._v(_vm._s(_vm.$t("modules.recordNotFound"))),
                      ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            { key: "2", attrs: { tab: _vm.$t("modules.relatedLists") } },
            [
              _c("ModuleRelatedList", {
                attrs: { tableId: _vm.tableId, recordId: _vm.recordId },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }